<section class="perm-panel" aria-live="polite">
  <header class="perm-panel__header">
    <div class="perm-panel__heading">
      @if (breadcrumb()) {
        <p class="perm-panel__breadcrumb">{{ breadcrumb() }}</p>
      }
      <h2 class="perm-panel__title">{{ node().label }}</h2>
      <p class="perm-panel__subtitle">
        <span>{{ subtitle() }}</span>
        @if (isReadOnly()) {
          <span
            class="perm-panel__state-tag"
            title="Menu e toda a leitura ligados, nenhuma gravação"
            >Só leitura</span
          >
        }
      </p>
    </div>
    <!-- Os três atalhos com o mesmo peso: nenhum parece um estado ligado (o estado real é o selo ao lado da contagem). -->
    <div class="perm-panel__presets" role="group" [attr.aria-label]="'Atalhos ' + presetScope()">
      <span class="perm-panel__presets-label">Aplicar:</span>
      <app-button
        [id]="'preset-read-only'"
        label="Só leitura"
        icon="eye"
        size="small"
        theme="white"
        [noMargin]="true"
        [title]="'Liga o menu e toda a leitura ' + presetScope() + ' e desliga a gravação'"
        (sendButtonClick)="apply('read-only')"></app-button>
      <app-button
        [id]="'preset-all'"
        label="Tudo"
        size="small"
        theme="white"
        [noMargin]="true"
        [title]="'Liga todas as permissões ' + presetScope()"
        (sendButtonClick)="apply('all')"></app-button>
      <app-button
        [id]="'preset-none'"
        label="Nada"
        size="small"
        theme="white"
        [noMargin]="true"
        [title]="'Desliga todas as permissões ' + presetScope()"
        (sendButtonClick)="apply('none')"></app-button>
    </div>
  </header>

  <div class="perm-panel__body">
    @if (screen(); as current) {
      @if (current.menuAction; as menu) {
        <div class="perm-panel__menu">
          <app-permission-action-row
            [action]="menu"
            [checked]="isChecked(menu)"
            [changed]="isChanged(menu)"
            (checkedChange)="toggle(menu, $event)"></app-permission-action-row>
          <p class="perm-panel__menu-note">
            Só esconde ou mostra o item no menu. Abrir a tela continua dependendo das permissões
            abaixo.
          </p>
        </div>
      }

      @if (current.readActions.length) {
        <div class="perm-panel__section">
          <div class="perm-panel__section-head">
            <i class="pi pi-eye perm-panel__section-icon perm-panel__section-icon--read"></i>
            <h3>Leitura</h3>
            <span class="perm-panel__pill perm-panel__pill--read"
              >{{ readCount().selected }} de {{ readCount().total }}</span
            >
            <span class="perm-panel__section-note">ver e consultar, não altera nada</span>
          </div>
          <div class="perm-panel__actions">
            @for (action of current.readActions; track action.value) {
              <app-permission-action-row
                class="perm-panel__action"
                [action]="action"
                [checked]="isChecked(action)"
                [changed]="isChanged(action)"
                [showGroup]="showGroups()"
                (checkedChange)="toggle(action, $event)"></app-permission-action-row>
            }
          </div>
        </div>
      }

      @if (current.writeActions.length) {
        <div class="perm-panel__section">
          <div class="perm-panel__section-head">
            <i class="pi pi-pencil perm-panel__section-icon perm-panel__section-icon--write"></i>
            <h3>Gravação</h3>
            <span class="perm-panel__pill perm-panel__pill--write"
              >{{ writeCount().selected }} de {{ writeCount().total }}</span
            >
            <span class="perm-panel__section-note">cria, altera ou apaga dados</span>
          </div>
          <div class="perm-panel__actions">
            @for (action of current.writeActions; track action.value) {
              <app-permission-action-row
                class="perm-panel__action"
                [action]="action"
                [checked]="isChecked(action)"
                [changed]="isChanged(action)"
                [showGroup]="showGroups()"
                (checkedChange)="toggle(action, $event)"></app-permission-action-row>
            }
          </div>
        </div>
      }

      @if (!current.readActions.length && !current.writeActions.length) {
        <p class="perm-panel__empty-note">
          Esta tela só tem o item de menu. As ações dela moram em outra tela da árvore.
        </p>
      }
    } @else {
      <ul class="perm-panel__screens">
        @for (item of childScreens(); track item.id) {
          @let itemCount = screenCount(item);
          <li>
            <button type="button" class="perm-panel__screen" (click)="screenOpen.emit(item)">
              <span class="perm-panel__screen-text">
                <span class="perm-panel__screen-label">
                  @if (node().kind === 'module' && item.path.length > 1) {
                    <span class="perm-panel__screen-area"
                      >{{ item.path[item.path.length - 1] }} ›</span
                    >
                  }
                  {{ item.label }}
                </span>
                <span class="perm-panel__screen-detail">
                  @if (item.menuAction) {
                    {{ isMenuOn(item) ? 'no menu' : 'fora do menu' }}
                    @if (screenDetail(item)) {
                      ·
                    }
                  }
                  {{ screenDetail(item) }}
                </span>
              </span>
              <span
                class="perm-panel__screen-count"
                [class.perm-panel__screen-count--some]="itemCount.selected > 0"
                >{{ itemCount.selected }}/{{ itemCount.total }}</span
              >
              <i class="pi pi-chevron-right perm-panel__screen-arrow"></i>
            </button>
          </li>
        }
      </ul>
    }
  </div>
</section>
